import { render, staticRenderFns } from "./ModalRequestPartnerDetail.vue?vue&type=template&id=2be92e38&scoped=true"
import script from "./ModalRequestPartnerDetail.vue?vue&type=script&lang=js"
export * from "./ModalRequestPartnerDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be92e38",
  null
  
)

export default component.exports